import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toPhone, toDate, toDateFromPtBr } from '@/modules/core/utils/formats';

export const getPaginatedEmpresasData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/empresas?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllEmpresasData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/empresas?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.identificador}"`,
    `"${data.razaoSocial}"`,
    `"${toDate(data.dataHoraCriacao)}"`,
    `"${toPhone(data.telefone)}"`,
    `"${toPhone(data.celular)}"`,
    `"${data.usuarios}"`,
    `"${data.totalOS}"`,
    data.municipio != null ? `"${data.municipio}"` : '',
    data.estado != null ? `"${data.estado}"` : '',
    `"${data.status}"`,
    `"${toDate(data.dataUltimaOs)}"`,
  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataCriacaoInicial: toDateFromPtBr(options.creationInitialDate),
  dataCriacaoFinal: toDateFromPtBr(options.creationEndDate),
  status: options.status,
});
